"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

const GTM_ID = "GTM-KXJMFNFV";
const ADSENSE_PUB_ID = "ca-pub-9042519310760920";

export default function ThirdPartyScripts() {
  useEffect(() => {
    let loaded = false;

    const loadScripts = () => {
      if (loaded) return;
      loaded = true;

      // 1. Initialize & load Google Tag Manager
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });

      const gtmScript = document.createElement("script");
      gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      gtmScript.async = true;
      document.head.appendChild(gtmScript);

      // 2. Load Google AdSense
      const adsScript = document.createElement("script");
      adsScript.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_PUB_ID}`;
      adsScript.async = true;
      adsScript.crossOrigin = "anonymous";
      document.head.appendChild(adsScript);
    };

    const onActivity = () => {
      loadScripts();
    };

    window.addEventListener("scroll", onActivity, { passive: true, once: true });
    window.addEventListener("mousemove", onActivity, { passive: true, once: true });
    window.addEventListener("touchstart", onActivity, { passive: true, once: true });
    window.addEventListener("keydown", onActivity, { passive: true, once: true });

    // Fallback load on idle after 4.5s if no interaction occurs
    const timer = setTimeout(() => {
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(loadScripts, { timeout: 2000 });
      } else {
        loadScripts();
      }
    }, 4500);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onActivity);
      window.removeEventListener("mousemove", onActivity);
      window.removeEventListener("touchstart", onActivity);
      window.removeEventListener("keydown", onActivity);
    };
  }, []);

  return null;
}
